/**
 * Chat API Service
 */
import apiClient from './client';
import type { ChatResponse, ChatHistoryResponse } from '../../types';

export const chatWithAnalysis = async (analysisId: string, message: string, includeFullText: boolean = false): Promise<ChatResponse> => {
  const response = await apiClient.post(`/api/analyses/${analysisId}/chat`, {
    message,
    include_full_text: includeFullText,
  });
  return response.data;
};

export const getChatHistory = async (analysisId: string): Promise<ChatHistoryResponse> => {
  const response = await apiClient.get(`/api/analyses/${analysisId}/chat/history`);
  return response.data;
};

export const exportChatConversation = async (analysisId: string, format: string = 'txt'): Promise<any> => {
  const response = await apiClient.get(`/api/analyses/${analysisId}/chat/export`, {
    params: { format },
    responseType: 'blob'
  });
  return response;
};
